export const mixins = {
    methods: {
        methodColor(method) {
            switch (method) {
                case 'get':
                    return `<span style="color: green">${method.toUpperCase()}</span>`
                case 'post':
                    return `<span style="color: orange">${method.toUpperCase()}</span>`
                case 'delete':
                    return `<span style="color: red">${method.toUpperCase()}</span>`
            }
        },

        _isEmptyObject(data) {
            return !!(data && Object.keys(data).length)
        }
    }
}
